/* eslint-disable react/require-default-props */
import React, { ReactNode } from 'react';
import { AdditionalStyles } from 'types/common/AdditionalStyles';

type TooltipProps = {
  message: string | undefined;
  cursor?: 'help' | 'pointer';
  children: ReactNode;
} & AdditionalStyles;

export default function Tooltip({ message, cursor, children, styles }: TooltipProps) {
  return (
    <div className="w-fit group relative flex" style={{ cursor }}>
      {children}
      {message && (
        <span
          className={`w-fit whitespace-normal z-[999] absolute left-1/2 -translate-x-1/2 -bottom-10 scale-0 transition-all rounded bg-gray-800 p-2 text-sm text-white group-hover:scale-100  ${styles}`}>
          {message}
        </span>
      )}
    </div>
  );
}
